import { createPortal } from "preact";
import { dismissToast, toasts } from "../../state/toasts";

/**
 * Fixed toast stack. Polite live region; clicking a toast dismisses it. Rendered into document.body
 * like modals: the menu root (#app) is a stacking context below the modal layer, so toasts raised
 * while a dialog is open would otherwise be hidden behind it.
 */
export function ToastHost() {
  const list = toasts.value;
  return createPortal(
    <div class="toasts" role="region" aria-label="Notifications" aria-live="polite">
      {list.map((t) => (
        <button
          key={t.id}
          type="button"
          class={`toast toast--${t.kind}`}
          onClick={() => dismissToast(t.id)}
          title="Dismiss"
        >
          <span class="toast__bar" aria-hidden="true" />
          <span class="toast__msg">{t.message}</span>
        </button>
      ))}
    </div>,
    document.body,
  );
}
